import cesStcwDetailsLocale from './en.json'

const en = {
  cesStcwDetails: cesStcwDetailsLocale,
}

export default en
